import { Cell, flexRender } from '@tanstack/react-table'
import { ColumnDefPro, ValidRowModel } from '../../utils/types'

export default function CellRenderer({
    cell,
}: {
    cell: Cell<ValidRowModel, unknown>
}) {
    const ogDef = (cell.column.columnDef as ColumnDefPro)._ogDef,
        row = cell.row.original,
        field = ogDef.field as string,
        id = cell.row.original.id ?? cell.row.id,
        value = cell.getValue()

    // RenderCell foi definido pela declaração da coluna
    if (ogDef.renderCell)
        return ogDef.renderCell({
            field,
            id,
            value,
            row,
            tableRow: cell.row,
        })

    // RenderCell foi modificado pela integrationLayer
    if (ogDef._hasCustomRenderCell)
        return flexRender(cell.column.columnDef.cell, cell.getContext())

    // Nenhum renderCell foi definido, então renderiza o valor em texto
    return (
        <span className="block truncate size-fit">
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </span>
    )
}
